import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { ThemeProvider, theme } from '@hub-la/design-system';
import { ContainerProvider } from '@hub-la/fe-container';
import { CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import { useQueryClient, QueryClientProvider } from 'react-query';
import i18n from '../../i18n.js';
import { CreateRealtimeSectionsProvider } from '../hooks/use-realtime-sections.js';
import '@hub-la/fe-core-http-client';
import '../../usecases/save-file.js';
import '../../domain/dtos/query-key.js';
import '../../usecases/save-post.js';
import 'react';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { CurrentUserProvider } from './current-user-provider.js';

const PostDetailInit = ({
  children,
  currentUser,
  container
}) => {
  const queryClient = useQueryClient();
  return jsx(ContainerProvider, Object.assign({
    container: container
  }, {
    children: jsxs(ThemeProvider, Object.assign({
      theme: theme.dark
    }, {
      children: [jsx(CssBaseline, {}), jsx(I18nextProvider, Object.assign({
        i18n: i18n
      }, {
        children: jsx(QueryClientProvider, Object.assign({
          client: queryClient
        }, {
          children: jsx(CurrentUserProvider, Object.assign({
            currentUser: currentUser
          }, {
            children: jsx(CreateRealtimeSectionsProvider, {
              children: children
            })
          }))
        }))
      }))]
    }))
  }));
};

export { PostDetailInit };
